
export const MuiStepConnector = {
    styleOverrides: {
        line: {
            borderColor: 'var(--mui-palette-secondary-main)'
        }
    }
}
